export default __webpack_public_path__ + "static/media/02-empathy-map.4f908ad9.svg";